import { genericActionNoMutation } from "@/utils/store-fns";
import { serverUrl } from "@/utils/env-variables-fns";

let actions = {
  GENERATESALESQUOTESPDF: (context, payload) => {
    return new Promise((resolve) => {
      genericActionNoMutation(
        context,
        payload,
        `${serverUrl}/global/generate-sales-quotes-pdf`
      ).then((response) => {
        resolve(response);
      });
    });
  },
  GENERATESALESSERVICEPDF: (context, payload) => {
    return new Promise((resolve) => {
      genericActionNoMutation(
        context,
        payload,
        `${serverUrl}/global/generate-sales-services-pdf`
      ).then((response) => {
        resolve(response);
      });
    });
  },
  GENERATEPURCHASEORDERPDF: (context, payload) => {
    return new Promise((resolve) => {
      genericActionNoMutation(
        context,
        payload,
        `${serverUrl}/global/generate-purchase-order-pdf`
      ).then((response) => {
        resolve(response);
      });
    });
  },
  GENERATEPAYMENTPDF: (context, payload) => {
    return new Promise((resolve) => {
      genericActionNoMutation(
        context,
        payload,
        `${serverUrl}/global/generate-payment-pdf`
      ).then((response) => {
        resolve(response);
      });
    });
  },
};

export default actions;
